import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinuxfoundationComponent } from './simple-icons-linuxfoundation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinuxfoundationComponent ],
    exports:      [ SimpleIconsLinuxfoundationComponent ],
    bootstrap:    []
})
export class SimpleIconsLinuxfoundationModule {}
